import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import config from '../../config/config'
import NotificationSystem from 'react-notification-system'
import { Table, TableBody, TableRowColumn, TableRow } from 'material-ui/Table'
import IconButton from 'material-ui/IconButton'
import Clipboard from 'react-clipboard.js'
import guesturl from '../../images/guesturl.png'
import hosturl from '../../images/hosturl.png'
import joinroom from '../../images/joinroom.png'
import ReactTooltip from 'react-tooltip'
import images from '../../config/images';
import { checkMobile, isIpadOS } from '../../lib'
import { TableHeader } from 'material-ui/Table'

const tdStyle = {
  padding: '0px',
  borderRight: '1px solid #b8b8b8',
  textAlign: 'center',
  whiteSpace: 'pre-wrap',
  overflow: 'visible'
}

const notificationStyleDesktop = {
  NotificationItem: {
    DefaultStyle: {
      fontSize: '14px',
      width: '25vw',
      top: '-4vw !important',
    }
  }
}

const Help = (props) => {
  return (
    <span>
      {checkMobile() || isIpadOS() ? <span></span> :<img
      data-tip={`<div class='rc-tooltip'>${props.content}</div>`}
      style={{ width: '16px', height: '16px', marginLeft: '5px', cursor: 'pointer' }}
      src={images.quetionMark}
    />}
    </span>
  )
}

const InvitationEmail = (props) => {
  return (
    <TableRowColumn style={tdStyle}>
      <IconButton
        onTouchTap={(e) => props.handleClick(props.val)}
        iconStyle={{ width: "28px" }}
        touchRippleColor="green"
      >
        <img src={images.sendIcon} alt={"部屋に入る"} />
      </IconButton>
    </TableRowColumn>
  )
}

class SessionsRoom extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rooms: [],
      showInput: false,
      password: '',
      showActionRow: null,
    }
    this.lockEnable = true;
  }

  joinRoom = (val) => {
    if (this.lockEnable) {
      window.open(this.copyHostURL(val))
    } else {
      window.open(this.copyURL(val.fvroom_name))
    }

  }

  joinWebinar = (val) => {
    window.open(this.copyWebinarPublisherUrl(val));
  }

  url = (name) => {
    let url = 'https://' + this.props.domainUrlName + '.lfv.jp/' + name;
    let subDomain = config.URI === 'https://workshop.tokyo' ? 'fv' : 'video-dev';

    if (this.props.domainType === 'Path Domain') {
      url = 'https://' + subDomain + '.lfv.jp/' + this.props.domainUrlName + '/' + name;
    }

    if (this.props.admin_guest_url) {
      url += '?video=true'
    }
    return url
  }
  copyURL = (name) => {
    return this.url(name)
  }
  copyGuestURL = (name) => {
    let url = ''
    url = 'https://' + this.props.domainUrlName + '.lfv.jp/' + name
    return url
  }

  copyWebinarUrl = (name) => {
    let url = this.copyURL(name);
    return url;
  }

  copyWebinarPublisherUrl = (val) => {
    let webinarUrl = this.props.admin_guest_url ? '&publisher=true' : '?publisher=true'
    let url = this.copyURL(val.fvroom_name) + webinarUrl;
    if (val.locked && val.hosttoken) {
      url += `&hosttoken=${val.hosttoken}`
    }
    return url;
  }

  copyHostURL = (val) => {
    let url = this.copyURL(val.fvroom_name)
    if (val.locked && val.hosttoken) {
      let hostUrlParam = this.props.admin_guest_url ? '&hosttoken=' : '?hosttoken='
      url = this.copyURL(val.fvroom_name) + hostUrlParam + val.hosttoken
    } else {
      url = url + '?host=true'
    }

    return url
  }


  // updateRoom = (id, payload) => {
  //   return fetch(`${config.URI}/api/v1/rooms/${id}`, {
  //     method: 'POST',
  //     headers: {
  //       'Authenticity-Token': getToken(),
  //       'Content-Type': 'application/json'
  //     },
  //     body: JSON.stringify(payload)
  //   })
  //     .then((temp) => temp.json())
  //     .then(res => {
  //       this.props.getRoom()
  //     })
  //     .catch((error) => {
  //       let warning = checkJapanese() ? 'サーバーとの接続にエラーが発生しました。' : 'There was an error connecting to the server.';
  //       alert(warning)
  //     })
  // }

  handlePopupStatus = () => {
    const { intl } = this.props;
    const notification = this.refs.notificationSystem
    notification.addNotification({
      message: intl.formatMessage({ id: "loggedInNavigation.urlCopy"}),
      level: 'success',
      position: 'tc',
      autoDismiss: 3
    })
  }

  handleHostPopupStatus = () => {
    const { intl } = this.props;
    const notification = this.refs.notificationSystem
    notification.addNotification({
      message: intl.formatMessage({ id: "loggedInNavigation.hostUrlCopy"}),
      level: 'success',
      position: 'tc',
      autoDismiss: 3
    })
  }

  handleWebinarPopupStatus = (key) => {
    const { intl } = this.props;
    const notification = this.refs.notificationSystem
    notification.addNotification({
      message: intl.formatMessage({ id: `loggedInNavigation.${key}`}),
      level: 'success',
      position: 'tc',
      autoDismiss: 3
    })
  }


  // onChangeLocked = (e, id) => {
  //   const payload = {
  //     locked: e.target.checked
  //   }
  //   return this.updateRoom(id, payload)
  // }

  handlePassword = (id, password) => {
    this.setState({
      showInput: id,
      password: password
    })
  }

  showActionRow = (id) => {
    let row = id;
    if (this.state.showActionRow == id) {
      row = null;
    }
    this.setState({
      showActionRow: row
    })
  }

  
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }
  // validate = (data) => {
  //   const errors = {}
  //   if (this.state.password && this.state.password.length > 20) errors.password = <FormattedMessage id="signUp.passwordError.long" />
  //   return errors
  // }
  // handleSubmit = (e, id) => {
  //   e.preventDefault()
  //   const errors = this.validate(this.state)
  //   this.setState({ errors })
  //   if (Object.keys(errors).length !== 0) {
  //     return
  //   }
  //   this.setState({
  //     showInput: ''
  //   })
  //   const payload = {
  //     fvroom_password: this.state.password
  //   }
  //   return this.updateRoom(id, payload)
  // }

  handleInvitationEmail = (room, isWebinar) => {
    let hostURL = isWebinar ? this.copyWebinarPublisherUrl(room) : this.copyHostURL(room);
    let guestURL = isWebinar ? this.copyWebinarUrl(room.fvroom_name) : this.copyURL(room.fvroom_name);
    this.props.handleInvitationEmail(room, hostURL, guestURL);
  }

  render() {
    const { intl } = this.props;
    const formatMessage = intl.formatMessage;

    const texts = {
      enterRoom: formatMessage({ id: 'helper.conference.enterRoom' }),
    }

    const webinarText = {
      enterRoom: formatMessage({ id: 'helper.webinar.enterRoom' }),
    }

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={notificationStyleDesktop} />
        <ReactTooltip place='top' multiline effect='solid' html />
        <div className='table-wrapper'>
          <Table fixedHeader={true} selectable={false} selectedColor="black" height={'70vh'} style={{border: '1px solid #b8b8b8'}}>
          <TableHeader displaySelectAll={false} enableSelectAll={false} adjustForCheckbox={false}>

              {/* Table header */}
              <TableRow style={{border: '1px solid #b8b8b8', backgroundColor: '#6B7c93', color: '#fff'}}>
                <TableRowColumn style={tdStyle}>{<FormattedMessage id='roomList.roomName' />}</TableRowColumn>
                {!this.props.isWebinar && 
                  <TableRowColumn style={tdStyle} >{<FormattedMessage id='roomList.invitationUrl' />}</TableRowColumn>
                }
                {!this.props.isWebinar && <TableRowColumn style={tdStyle} >{<FormattedMessage id='roomList.hostUrl' />}</TableRowColumn>}
                {!this.props.isWebinar && <TableRowColumn style={tdStyle} >{<FormattedMessage id='roomList.invitationEmail' />}</TableRowColumn>}
                {!this.props.isWebinar && <TableRowColumn style={tdStyle} >{<FormattedMessage id='roomList.enterRoom' />}
                  <Help content={texts.enterRoom} />
                </TableRowColumn>}
                {this.props.isWebinar &&  <TableRowColumn style={tdStyle} >{<FormattedMessage id='roomList.participantUrl' />}</TableRowColumn> }
                {this.props.isWebinar && <TableRowColumn style={tdStyle} >{<FormattedMessage id='roomList.lectureUrl' />}</TableRowColumn>}
                {this.props.isWebinar && <TableRowColumn style={tdStyle} >{<FormattedMessage id='roomList.invitationEmail' />}</TableRowColumn>}
                {this.props.isWebinar && <TableRowColumn style={tdStyle} >{<FormattedMessage id='roomList.enterRoom' />}
                <Help content={webinarText.enterRoom} />
                </TableRowColumn> }
                <TableRowColumn className='flex-center' style={tdStyle}>{<FormattedMessage id='roomList.edit' />}</TableRowColumn>
              </TableRow>
          </TableHeader>
            <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>


              {
                this.props.isFetching || (this.props.rooms.length === 0 && (
                  <TableRow
                    selected={false}
                    className="light-row"
                    style={{
                      backgroundColor: "#f2f3f6",
                      borderBottom: "1px solid #b8b8b8",
                      color: "rgb(107, 124, 147)",
                    }}
                  >
                    <TableRowColumn colSpan={6} style={tdStyle}>
                      {this.props.isFetching
                        ? <FormattedMessage id="roomList.fetchingRooms" />
                        : <FormattedMessage id="roomList.noRoom" />}
                    </TableRowColumn>
                  </TableRow>
                ))
              }

              {
                this.props.rooms.map((val, index) => (
                  <TableRow
                    key={index}
                    selected={false}
                    className={index % 2 == 0 ? "dark-row" : "light-row"}
                    style={{ backgroundColor: "#f2f3f6", borderBottom: "1px solid #b8b8b8" }}
                  >
                    <TableRowColumn style={tdStyle} className="room-name">
                      <p className="room-name"> {val.fvroom_name} </p>
                    </TableRowColumn>

                    {!this.props.isWebinar && (
                      <TableRowColumn style={tdStyle}>
                        <Clipboard
                          data-clipboard-text={this.copyURL(val.fvroom_name)}
                          onSuccess={this.handlePopupStatus}
                          style={{
                            border: "none",
                            background: "transparent",
                            padding: "0px",
                          }}
                        >
                          <IconButton
                            iconStyle={{ width: "20px" }}
                            touchRippleColor="green"
                          >
                            <img src={guesturl} />
                          </IconButton>
                        </Clipboard>
                      </TableRowColumn>
                    )}

                    {!this.props.isWebinar && (
                      <TableRowColumn style={tdStyle}>
                        <Clipboard
                          data-clipboard-text={this.copyHostURL(val)}
                          onSuccess={this.handleHostPopupStatus}
                          style={{ border: "none", background: "transparent", width: "60px" }}
                        >
                          <IconButton
                            iconStyle={{ width: "28px" }}
                            touchRippleColor="green"
                          >
                            <img src={hosturl} />
                          </IconButton>
                        </Clipboard>
                      </TableRowColumn>
                    )}

                    {!this.props.isWebinar && (
                      <InvitationEmail handleClick={(room) => this.handleInvitationEmail(room, false)} val={val} />
                    )}

                    {!this.props.isWebinar && (
                      <TableRowColumn style={tdStyle}>
                        <IconButton
                          onTouchTap={(e) => this.joinRoom(val)}
                          iconStyle={{ width: "28px" }}
                          touchRippleColor="green"
                        >
                          <img src={joinroom} alt={"部屋に入る"} />
                        </IconButton>
                      </TableRowColumn>
                    )}

                    {this.props.isWebinar && (
                      <TableRowColumn style={tdStyle}>
                        <Clipboard
                          data-clipboard-text={this.copyWebinarUrl(val.fvroom_name)}
                          onSuccess={() =>
                            this.handleWebinarPopupStatus("webinarUrlCopiedMessage")
                          }
                          style={{
                            border: "none",
                            background: "transparent",
                            padding: "0px",
                          }}
                        >
                          <IconButton
                            iconStyle={{ width: "28px" }}
                            touchRippleColor="green"
                          >
                            <img src={guesturl} />
                          </IconButton>
                        </Clipboard>
                      </TableRowColumn>
                    )}

                    {this.props.isWebinar && (
                      <TableRowColumn style={tdStyle}>
                        <Clipboard
                          data-clipboard-text={this.copyWebinarPublisherUrl(val)}
                          onSuccess={() =>
                            this.handleWebinarPopupStatus("webinarPublisherUrlCopiedMessage")
                          }
                          style={{ border: "none", background: "transparent", width: "60px" }}
                        >
                          <IconButton
                            iconStyle={{ width: "28px" }}
                            touchRippleColor="green"
                          >
                            <img src={hosturl} />
                          </IconButton>
                        </Clipboard>
                      </TableRowColumn>
                    )}

                    {this.props.isWebinar && (
                      <InvitationEmail handleClick={(room) => this.handleInvitationEmail(room, true)} val={val} />
                    )}

                    {this.props.isWebinar && (
                      <TableRowColumn style={tdStyle}>
                        <IconButton
                          onTouchTap={(e) => this.joinWebinar(val)}
                          iconStyle={{ width: "28px" }}
                          touchRippleColor="green"
                        >
                          <img src={joinroom} alt={"部屋に入る"} />
                        </IconButton>
                      </TableRowColumn>
                    )}

                    <TableRowColumn style={tdStyle}>
                      <IconButton
                        onClick={(e) => this.props.editRoom(val)}
                        iconStyle={{ height: "23px" }}
                        touchRippleColor="red"
                      >
                        <img src={images.editIcon} />
                      </IconButton>
                    </TableRowColumn>
                  </TableRow>
                ))
              }

            </TableBody>
          </Table>
        </div>
      </div>
    )
  }
}

export default injectIntl(SessionsRoom);



// WEBPACK FOOTER //
// src/components/Seminars/SessionsRoom.js